import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ReportedHoursConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ReportedHoursService } from './api/reportedHours.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ReportedHoursApiModule {
    public static forRoot(configurationFactory: () => ReportedHoursConfiguration): ModuleWithProviders<ReportedHoursApiModule> {
        return {
            ngModule: ReportedHoursApiModule,
            providers: [ { provide: ReportedHoursConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ReportedHoursApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ReportedHoursApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
